// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");
let ConversationsListRelayPaginationQuery_graphql = require("./ConversationsListRelayPaginationQuery_graphql.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"accountConversations_edges_node_lastMessage_sentAt":{"b":""},"accountConversations_edges_node":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "ConversationsListRelay_query_accountConversations", undefined);
}

function getConnectionNodes(connection) {
  let edges = connection.edges;
  if (edges !== undefined) {
    return Stdlib_Array.filterMap(edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

function makeNode(rescript_graphql_node_ConversationsListRelayPaginationQuery) {
  return ((function(){
var v0 = [
  "accountConversations"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_ConversationsListRelayPaginationQuery
    }
  },
  "name": "ConversationsListRelay_query",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "accountConversations",
        "args": null,
        "concreteType": "QueryConversationV5Connection",
        "kind": "LinkedField",
        "name": "__ConversationsListRelay_query_accountConversations_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryConversationV5Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationMessageV5",
                    "kind": "LinkedField",
                    "name": "lastMessage",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sentAt",
                          "storageKey": null
                        },
                        "action": "NONE"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsListItem_conversation"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());
}

let node = makeNode(ConversationsListRelayPaginationQuery_graphql.node);

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
